export const LC_CONTENT_CDN = 'https://lantern-lc-multimedia.aws.wgen.net';

export default LC_CONTENT_CDN;
